<template>
  <iframe
    class="embeded-google-map"
    title="Google map"
    style="border: 0"
    :src="src"
    loading="lazy"
    allowfullscreen
  ></iframe>
</template>

<script>
export default {
  props: {
    src: String,
  },
};
</script>

<style lang="scss" scoped>
.embeded-google-map {
  width: 100%;
}
</style>
